import { render, staticRenderFns } from "./InstagramAnnouncementSettings.vue?vue&type=template&id=f65285a0"
import script from "./InstagramAnnouncementSettings.vue?vue&type=script&lang=js"
export * from "./InstagramAnnouncementSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports